export default __webpack_public_path__ + "static/media/conversation-bubbles.991be1ca.svg";